import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    rowLength: number;
    header?: boolean;
    cellAlignment?: string;
    rowClickable?: boolean;
    cellClickable?: boolean;
    variant: 'reports' | 'default';
  }>()
  .create(
    ({
      theme,
      header,
      cellAlignment,
      rowLength,
      rowClickable,
      cellClickable,
      variant
    }) => ({
      cardLoading: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'calc(100% - 4rem)',
        minHeight: '100%',
        backdropFilter: 'blur(0px)'
      },
      tableCard: {
        height: '100%',
        width: '100%',
        boxShadow: variant === 'reports' ? 'none' : theme.vars.shadows[1]
      },
      tableCardContent: {
        height: rowLength > 0 ? '100%' : '',
        maxHeight: '100%',
        padding: '0px !important'
      },
      tableCardHeader: {
        borderBottom:
          variant === 'reports'
            ? ''
            : `1px solid ${theme.vars.palette.divider}`,
        fontWeight: 600,
        padding: variant === 'reports' ? '0 !important' : '0.5rem 1rem',
        minHeight: variant === 'reports' ? '12px' : '3rem',
        textTransform: variant === 'reports' ? 'uppercase' : 'none',
        '& .MuiTypography-root': {
          fontSize: variant === 'reports' ? '14px' : '0.875rem',
          fontWeight: variant === 'reports' ? 600 : 400,
          lineHeight: '1.5rem'
        },
        backgroundColor: variant === 'reports' ? 'white' : ''
      },
      tableSecondaryText: {
        color: theme.vars.palette.secondary.light
      },
      tableWidget: {
        color: variant === 'reports' ? 'black' : '',
        '.MuiDataGrid-root': {
          backgroundColor:
            variant === 'reports'
              ? 'white'
              : theme.vars.palette.background.elevation2
        },
        backgroundColor:
          variant === 'reports'
            ? 'white'
            : theme.vars.palette.background.elevation2,
        '.MuiDataGrid-columnHeader': {
          backgroundColor:
            variant === 'reports'
              ? 'white'
              : theme.vars.palette.background.elevation2
        },
        '.MuiDataGrid-columnHeaders': {
          display: header ? '' : 'none'
        },
        '.MuiDataGrid-cell': {
          display: 'flex',
          paddingLeft: '1rem',
          paddingTop: '0.5rem',
          paddingBottom: '0.5rem',
          alignItems: cellAlignment || 'flex-start',
          cursor: rowClickable || cellClickable ? 'pointer' : ''
        },
        '.MuiDataGrid-topContainer': {
          backgroundColor:
            variant === 'reports'
              ? 'white'
              : theme.vars.palette.background.elevation2
        },
        '.MuiDataGrid-virtualScroller': {
          overflowX: 'auto',
          overflowY: rowLength > 0 ? 'auto' : 'hidden',
          '.MuiDataGrid-overlayWrapper': {
            height: '100%!important',
            '.MuiDataGrid-overlayWrapperInner': {
              height: '100%!important'
            }
          }
        },
        '.MuiDataGrid-scrollbar': {
          display: variant === 'reports' ? 'none' : 'inline-block'
        },
        '.MuiDataGrid-columnSeparator--resizable': {
          display: variant === 'reports' ? 'none' : ''
        },
        '.MuiDataGrid-scrollbarFiller': {
          backgroundColor: variant === 'reports' ? 'white' : 'transparent'
        }
      }
    })
  );

export default useStyles;
